import React from 'react';
import { Link } from 'react-router-dom';
import { elementGroups } from '../data/periodicTableData';
import ElementCard from './ElementCard';
const PeriodicTable: React.FC = () => {
  return <div className="space-y-8" data-id="element-43">
      <div className="bg-white rounded-lg shadow-md p-6" data-id="element-44">
        <h2 className="text-2xl font-semibold mb-4" data-id="element-45">
          Welcome to the Periodic Table Explorer
        </h2>
        <p className="mb-4" data-id="element-46">
          Explore the chemical elements organized by their groups. Click on any
          group below to see its elements, or browse the featured elements from
          various groups.
        </p>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-6" data-id="element-47">
          {Object.entries(elementGroups).map(([groupId, group]) => <Link key={groupId} to={`/group/${groupId}`} className="bg-blue-50 hover:bg-blue-100 border border-blue-200 rounded-lg p-4 transition-colors" data-id="element-48">
              <h3 className="font-medium text-lg" data-id="element-49">{group.name}</h3>
              <p className="text-sm text-gray-600" data-id="element-50">
                {group.elements.length} elements
              </p>
            </Link>)}
        </div>
      </div>
      <div className="bg-white rounded-lg shadow-md p-6" data-id="element-51">
        <h2 className="text-2xl font-semibold mb-4" data-id="element-52">Featured Elements</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6" data-id="element-53">
          {[elementGroups.alkali_metals.elements[0], elementGroups.noble_gases.elements[0], elementGroups.transition_metals.elements[0], elementGroups.nonmetals.elements[0]].map(element => <ElementCard key={element.atomicNumber} element={element} data-id="element-54" />)}
        </div>
      </div>
    </div>;
};
export default PeriodicTable;